import jwtAxios from "@crema/services/auth/jwt-auth";
import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    GET_NEWS_DETAILS,
    GET_NEWS_UPDATE,
    GET_USER_BDAY,
    NOTIFICATIONS,
    READ_NOTIFICATIONS,
    SHOW_MESSAGE,
    WISH_USER_BDAY,
} from "shared/constants/ActionTypes";

export const getNewsAndUpdate = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get("admin/get-all-news")
            .then((response) => {
                if (response.data.httpStatus == "OK") {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: GET_NEWS_UPDATE,
                        payload: response.data.data,
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.response.data.message || "Something went Wrong" });
            });
    };
};
export const getNewsDetailsById = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get(`admin/get-news/${id}`)
            .then((response) => {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({
                    type: GET_NEWS_DETAILS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.response.data.message || "Something went Wrong" });
            });
    };
};
export const getUserBirthDay = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get("issue/get-all-birthday-list")
            .then((response) => {
                if (response.data.status == "200") {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: GET_USER_BDAY,
                        payload: response.data.data,
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.response.data.message || "Something went Wrong" });
            });
    };
};

export const wishUserBday = (payload, setOpen) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .post("issue/wish-birthday", payload)
            .then((response) => {
                if (response.data.status == "200") {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: WISH_USER_BDAY,
                        payload: response.data.data,
                    });
                    setOpen(false);
                    dispatch({ type: SHOW_MESSAGE, payload: response.data.message });
                }
            })
            .then((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.response.data.message || "Something went Wrong" });
            });
    };
};
export const getNotifications = (page = 0, limit = 2) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get(`issue/get-av-notification?page=${page}&limit=${limit}`)
            .then((response) => {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({
                    type: NOTIFICATIONS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.response.data.message || "Something went Wrong" });
            });
    };
};
export const readNotifications = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .post(`issue/read-av-notification/${id}`)
            .then((response) => {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({
                    type: READ_NOTIFICATIONS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.response.data.message || "Something went Wrong" });
            });
    };
};
